// extracted by mini-css-extract-plugin
export default {"container":"HeaderSideNav_container__0lOJj","close":"HeaderSideNav_close__HHsKP"};